import { render, staticRenderFns } from "./LoadingSpeedInfoCardSkeleton.vue?vue&type=template&id=e8c1b72e&scoped=true"
import script from "./LoadingSpeedInfoCardSkeleton.vue?vue&type=script&lang=js"
export * from "./LoadingSpeedInfoCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./LoadingSpeedInfoCardSkeleton.vue?vue&type=style&index=0&id=e8c1b72e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c1b72e",
  null
  
)

export default component.exports